export default "__VITE_ASSET__DgqdnKTU__"